import { FormattedMessage } from 'dibs-react-intl';

const CheckoutRemoveAction = () => (
    <FormattedMessage id="checkout.CheckoutRemoveAction.remove" defaultMessage="Remove" />
);

export default CheckoutRemoveAction;
